// ABOUTME: Pure client-side derive helpers for the cross-customer orders overview.
// ABOUTME: Trend %, Dutch number format, strongest riser/faller, bar height, month label.

const DUTCH_MONTHS = ['Januari','Februari','Maart','April','Mei','Juni','Juli','Augustus','September','Oktober','November','December'];

// Trend % vs previous window. Returns null when there is no comparable previous (prevTotal 0).
export const trendPct = (total, prevTotal) => {
    if (!prevTotal) return null;
    return Math.round(((total - prevTotal) / prevTotal) * 100);
};

// Dutch-grouped integer, e.g. 45147 -> "45.147".
export const formatNL = (n) => new Intl.NumberFormat('nl-NL').format(n || 0);

// Highest and lowest trend % across customers (ignoring those without a previous window).
export const strongest = (customers) => {
    const withTrend = (customers || [])
        .map(c => ({ ...c, _t: trendPct(c.total, c.prevTotal) }))
        .filter(c => c._t !== null);
    if (withTrend.length === 0) return { stijger: null, daler: null };
    let stijger = withTrend[0], daler = withTrend[0];
    for (const c of withTrend) {
        if (c._t > stijger._t) stijger = c;
        if (c._t < daler._t) daler = c;
    }
    return { stijger, daler };
};

// Bar height as a % of the row's own max value (per-row scaling). All-zero -> 0.
export const barHeightPct = (value, rowMax) => {
    if (!rowMax) return 0;
    return Math.round((value / rowMax) * 100);
};

// "Mei 2026" from year + 1-based month.
export const monthLabel = (year, month1) => `${DUTCH_MONTHS[month1 - 1]} ${year}`;
